import DeviceIntegrationManager from './DeviceIntegrationManager';
export default DeviceIntegrationManager;
